import { ErrorContent } from '../../fetcher';

export const commonError: ErrorContent = {
  title: 'アクセスしようとしたページを表示できませんでした',
  japanese:
    '大変申し訳ございません、ただ今つながりにくくなっております。<br />今しばらくお待ち頂き、再度アクセスしてください。',
  english:
    'The site is currently experiencing a high volume of traffic.<br />Please try again later. We are sorry for the inconvenience.',
};
